import { ModuleBackgroundColors, ModulePadding } from '../../shared/components/v2/ModuleSection/ModuleSection'
import { TEXT_FONT_COLOR, TEXT_FONT_STYLE, TEXT_TAG } from '../../shared/components/v2/Text/TextV2'
import { IBillboardWithContentCardsProps } from '../../shared/components/v2/BillboardWithContentCards/BillboardWithContentCards'
import { IBillboardWithImageProps } from '../../shared/components/v2/BillboardWithImage/BillboardWithImage'

export const contactUsFeaturesBillboardWithContentCardsProps: IBillboardWithContentCardsProps = {
  moduleBackgroundColor: { desktop: ModuleBackgroundColors.white },
  modulePadding: { top: ModulePadding.MD, bottom: ModulePadding.L },
  mobileModulePadding: { top: ModulePadding.XS, bottom: ModulePadding.MD },
  dataTestId: 'contact-us-features-billboard-with-content-cards-1',
  copyLocation: 'left',
  eyebrowText: {
    tag: TEXT_TAG.h5,
    text: 'Customer Care',
    textFontStyle: TEXT_FONT_STYLE.eyebrow,
    textFontColor: TEXT_FONT_COLOR.copperDark,
  },
  title: {
    tag: TEXT_TAG.h2,
    text: 'Instant support from real human beings<sup>1</sup>',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text: 'Talk to a local customer support expert who understands your business.',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
    {
      tag: TEXT_TAG.p,
      text: 'Want to see how quickly we’ll answer?\n Click the chat box in the corner and say hello.',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],
  contentCards: [
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'Live chat',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      body: {
        tag: TEXT_TAG.p,
        text: 'Talk to the team through our app or website.',
        textFontStyle: TEXT_FONT_STYLE.bodyMedium,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      imageSrc: '/static/v2/illustrations/can-telephone.png',
      imageAlt: 'Can Telephone',
      onClick: (): void => {
        if (window.Intercom) {
          window.Intercom('show')
        }
      },
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'Phone',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      body: {
        tag: TEXT_TAG.p,
        text: 'Never wait on hold again. We’ll call you.',
        textFontStyle: TEXT_FONT_STYLE.bodyMedium,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      imageSrc: '/static/v2/illustrations/phone.png',
      imageAlt: 'Phone',
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'Email',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      body: {
        tag: TEXT_TAG.p,
        text: 'Expect a fast, human response.',
        textFontStyle: TEXT_FONT_STYLE.bodyMedium,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
      },
      imageSrc: '/static/v2/illustrations/mailbox.png',
      imageAlt: 'Mailbox',
      link: 'mailto:support@northone.com',
    },
  ],
}

export const contactUsBillboardProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.copperTint4,
    mobile: ModuleBackgroundColors.copperTint4,
  },
  modulePadding: { top: ModulePadding.XL, bottom: ModulePadding.MD },
  mobileModulePadding: { top: ModulePadding.L, bottom: ModulePadding.NONE },
  copyLocation: 'left',
  dataTestId: 'contact-us-billboard-with-image',
  title: {
    tag: TEXT_TAG.h1,
    text: 'Contact us',
    textFontStyle: TEXT_FONT_STYLE.h1,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text:
        "We're making NorthOne better every day. But we need your help to make it perfect. Our customer care team is there for your business when you need it most.",
      textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],
  billboardImage: {
    src: '/static/v2/contact-us/contact-us-landing.png',
    mobileSrc: '/static/v2/contact-us/contact-us-landing-mobile.png',
    alt: 'Phone with message from customer service',
  },
}

const path = '/static/v2/locations-block'
export const contactUsLocationsBlock = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.copperPrimary,
    mobile: ModuleBackgroundColors.copperPrimary,
  },
  modulePadding: {
    top: ModulePadding.NONE,
    bottom: ModulePadding.NONE,
  },

  dataTestId: 'contact-us-locations',
  locations: [
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'New York O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '18 West 18th Street,\nNew York, NY 10011',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-New-York-City-icon.svg`,
      iconAltText: 'blue statue of liberty graphic',
      mapSrc: `${path}/New-York-Office-map.png`,
      mapAltText: 'blue statue of liberty graphic',
      mapLink:
        'https://www.google.com/maps/place/18+W+18th+St,+New+York,+NY+10011/@40.7390047,-73.9955218,17z/data=!3m1!4b1!4m5!3m4!1s0x89c259a2dd0576f9:0x8caea46dadd751c6!8m2!3d40.7390007!4d-73.9933331?shorturl=1',
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'San Francisco O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '650 California St., Floor 7\nSan Francisco, CA 94108',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-San-Francisco-icon.svg`,
      iconAltText: 'Golden Gate Bridge icon',
      mapSrc: `${path}/San-Francisco-Office-map.png`,
      mapAltText: 'Golden Gate Bridge icon',
      mapLink:
        'https://www.google.com/maps/place/650+California+St,+San+Francisco,+CA+94108,+USA/@37.7927929,-122.4072887,17z/data=!3m1!4b1!4m5!3m4!1s0x808581a2b338135f:0xb2d0c4277502c135!8m2!3d37.7927929!4d-122.4051',
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'Portland O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '920 SW 6th Ave, Suite 1200\nPortland, OR 97204',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-Portland-icon.svg`,
      iconAltText: ' Portland tree icon',
      mapSrc: `${path}/Portland-Office-map.png`,
      mapAltText: 'Portland tree icon',
      mapLink:
        'https://www.google.com/maps/place/Public+Service+Building,+920+SW+6th+Ave+Ste+1200,+Portland,+OR+97204,+USA/@45.5173353,-122.6813817,17z/data=!3m1!4b1!4m5!3m4!1s0x54950a0545d1f5d3:0x4f91a61c3e637157!8m2!3d45.5173353!4d-122.679193',
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'Toronto O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '1050 King St W\nToronto, ON M6K 0C7',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-Toronto-icon.svg`,
      iconAltText: 'The CN tower in Toronto Canada',
      mapSrc: `${path}/Toronto-Office-map.png`,
      mapAltText: 'The CN tower in Toronto Canada',
      mapLink: 'https://goo.gl/maps/fcUx2MbqMXP14o168',
    },
  ],
}
